export class userregistration {
    UserName:string="";
    password:string="";
    confirmPassword:string="";
    Id:string;
}